export const loadJsonFromLocalStorage = <T>(
  key: string,
  fallback: T,
  normalize?: (value: any) => T
): T => {
  if (typeof window === 'undefined') {
    return fallback;
  }

  try {
    const raw = localStorage.getItem(key);
    if (!raw) {
      return fallback;
    }

    const parsed = JSON.parse(raw);
    return normalize ? normalize(parsed) : (parsed as T);
  }
  catch {
    return fallback;
  }
};

export const saveJsonToLocalStorage = <T>(key: string, value: T): void => {
  if (typeof window === 'undefined') {
    return;
  }

  try {
    localStorage.setItem(key, JSON.stringify(value));
  }
  catch {
    // Intentionally ignore storage write errors (private mode/quota exceeded)
  }
};

export const removeLocalStorageItem = (key: string): void => {
  if (typeof window === 'undefined') {
    return;
  }

  try {
    localStorage.removeItem(key);
  }
  catch {
    // Intentionally ignore storage remove errors
  }
};

export const removeLocalStorageItems = (keys: string[]): void => {
  keys.forEach((key) => removeLocalStorageItem(key));
};
